import React, { useState, useRef, useEffect } from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  loading = "lazy",
  ...props
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const imgRef = useRef(null);

  useEffect(() => {
    // Use Intersection Observer for lazy loading
    if (loading === 'lazy' && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setIsInView(true);
              observer.disconnect();
            }
          });
        },
        { rootMargin: '50px' } // Start loading 50px before image enters viewport
      );

      if (imgRef.current) {
        observer.observe(imgRef.current);
      }

      return () => {
        if (imgRef.current) {
          observer.unobserve(imgRef.current);
        }
      };
    } else {
      // If IntersectionObserver is not supported or loading is eager, load immediately
      setIsInView(true);
    }
  }, [loading]);

  return (
    <img
      ref={imgRef}
      src={isInView ? src : undefined}
      alt={alt}
      className={`${className} ${!isLoaded ? 'opacity-0 transition-opacity duration-300' : 'opacity-100'}`}
      loading={loading}
      onLoad={() => setIsLoaded(true)}
      onError={(e) => {
        e.target.src = "/assets/images/no_image.png";
        setIsLoaded(true);
      }}
      {...props}
    />
  );
}

export default React.memo(Image);
